import React, { useCallback, useContext, useEffect, useState } from "react";
import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import clsx from "clsx";

import EditCategory from "../../../templates/teacher/EditCategory";
import styles from "../common.module.scss";
import {
  Context,
  UPDATE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_SUCCESS,
  deleteCategory,
  fetchCategories,
  updateCategory,
  reorderCategories,
  REORDER_CATEGORIES_SUCCESS,
} from "../../../store/teacher";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import Toast from "../../../molecules/Toast";

const EditCategoryPage = () => {
  const { dispatch, contextState } = useContext(Context);
  const [calling, peep] = useWaitApiCall(contextState);
  const [toastMessage, setToastMessage] = useState("");

  const fetchCategoriesFunc = useCallback(() => {
    dispatch(peep(fetchCategories()));
  }, [dispatch, peep]);

  const updateCategoryFunc = (
    id: number,
    params: {
      name: string;
      class_ids: number[];
      color: string;
    },
  ) => {
    !calling && dispatch(peep(updateCategory(id, params)));
  };

  const deleteCategoryFunc = (id: number) => {
    !calling && dispatch(peep(deleteCategory(id)));
  };

  const reorderCategoriesFunc = (ids: number[]) => {
    !calling && dispatch(peep(reorderCategories(ids)));
  };

  useIonViewWillEnter(() => {
    fetchCategoriesFunc();
  });

  useEffect(() => {
    if (
      contextState.lastAction !== UPDATE_CATEGORY_SUCCESS &&
      contextState.lastAction !== DELETE_CATEGORY_SUCCESS &&
      contextState.lastAction !== REORDER_CATEGORIES_SUCCESS
    )
      return;

    contextState.lastAction !== REORDER_CATEGORIES_SUCCESS &&
      setToastMessage(contextState.success_message);
    fetchCategoriesFunc();
  }, [contextState, fetchCategoriesFunc]);

  return (
    <IonPage>
      <IonContent className={clsx(styles.wrapper, styles.bgWhileBase)}>
        <Toast
          type="success"
          showToast={!!toastMessage}
          onClose={() => setToastMessage("")}
          message={toastMessage}
        />
        <div className={styles.container}>
          <EditCategory
            propsCategories={contextState.categories}
            assignedClasses={contextState.teacher.classes}
            calling={calling}
            updateCategory={updateCategoryFunc}
            deleteCategory={deleteCategoryFunc}
            reorderCategories={reorderCategoriesFunc}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default EditCategoryPage;
